import React from 'react'
import './GetInTouch.css'
import posed, { PoseGroup } from 'react-pose'

import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import HeaderIcon from '../../fields/HeaderIcon/HeaderIcon';

const MESSAGES = {
  FOOTER_MSG: 'Make sure you enter a working email ID.',
  ERROR_MSG: 'Make sure your email ID is correctly formatted and you have entered a message!'
}

const SubmitFormAnimate = posed.div({
  enter: { y: 0, opacity: 1 },
  exit: { y: 100, opacity: 0, transition: { duration: 30 } }
})
const ThankYouMsgAnimate = posed.div({
  enter: { y: 0, opacity: 1 },
  exit: { y: 100, opacity: 0, transition: { duration: 30 } }
})

export default class GetInTouch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSubmitting: false,
      subject: '', // email
      body: '',
      footerMessage: MESSAGES.FOOTER_MSG
    }
    this.onSubmitHandler = this.onSubmitHandler.bind(this)
    this.handleChangeSubject = this.handleChangeSubject.bind(this)
    this.handleChangeBody = this.handleChangeBody.bind(this)
  }

  isFormValid() {
    const { subject, body } = this.state
    // eslint-disable-next-line
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!subject || !body) {
      return false
    }

    if (!emailRegex.test(subject)) {
      return false
    }

    return true
  }

  onSubmitHandler() {
    const isFormValid = this.isFormValid()
    if (!isFormValid) {
      this.setState({ footerMessage: MESSAGES.ERROR_MSG })
      setTimeout(() => {
        this.setState({ footerMessage: MESSAGES.FOOTER_MSG })
      }, 3000)
      return
    }
    this.setState({ isSubmitting: true })
    fetch('https://gentle-badlands-88321.herokuapp.com/sendEmail', {
      method: 'POST',
      body: JSON.stringify({
        subject: this.state.subject,
        body: this.state.body
      }),
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(function(result) {
      console.log('Your email has been sent')
    })
    .catch(err => {
      console.error(err)
    })

    setTimeout(() => {
      this.setState({ isSubmitting: false, body: '', subject: '' })
    }, 3000)
  }

  handleChangeBody(e) {
    this.setState({ body: e.target.value })
  }

  handleChangeSubject(e) {
    this.setState({ subject: e.target.value })
  }

  renderSubmitForm () {
    return (
      <SubmitFormAnimate key='submitForm' className='submit-form' pose={ this.state.isSubmitting ? 'hidden' : 'visible' }>
        <TextField value={this.state.subject} onChange={this.handleChangeSubject} className='input-field margin30 bg-light-blue custom-style' variant='outlined' label='Your email' type='email'/>
        <TextField value={this.state.body} onChange={this.handleChangeBody} className='input-field margin30 bg-light-blue custom-style' multiline variant='outlined' rowsMax="4" label='Say something' rows='2'/>
        <Button className='margin30' size='large' variant='contained' color='secondary' onClick={this.onSubmitHandler}>Send Me A Message</Button>
      </SubmitFormAnimate>
    )
  }

  renderThankYouMsg() {
    return (
      <ThankYouMsgAnimate key='thankYouMsg' className='thank-you-msg' pose={ !this.state.isSubmitting ? 'hidden' : 'visible' }> Thanks for writing in! </ThankYouMsgAnimate>
    )
  }
 
  render () {
    return (
      <div className='screen-fullscreen screen irregular-bg-blue'>
        <div className='screen-content'>
          <h1><HeaderIcon icon='FaCoffee'/> Get In Touch</h1>
          <div className='main-form'>
            <PoseGroup>
              { !this.state.isSubmitting && this.renderSubmitForm() }
              { this.state.isSubmitting && this.renderThankYouMsg() }
            </PoseGroup>
          </div>
          {!this.state.isSubmitting && <p className='user-message'>{this.state.footerMessage}</p>}
        </div>
      </div>
    )
  }
}
